const variantClasses = {
  default:
    "bg-white text-cerulean text-[13px] font-semibold px-3.5 py-1.5 border border-cerulean/20",
  ice: "bg-ice text-cerulean text-[13px] font-semibold px-3.5 py-1.5",
  eyebrow: "bg-ice text-cerulean eyebrow px-3.5 py-1.5",
};

/**
 * Rounded inline tag used for hero badges and section eyebrows.
 *
 * @param {Object} props
 * @param {import("react").ReactNode} props.children - pill content
 * @param {boolean} [props.dot] - show a pulsing azure dot on the left
 * @param {string} [props.badge] - leading coral badge chip text (e.g., "NEW")
 * @param {import("react").ReactNode} [props.icon] - leading icon
 * @param {"default" | "ice" | "eyebrow"} [props.variant] - background variant
 * @param {string} [props.className] - extra classes
 * @returns {import("react").ReactElement}
 */
export function Pill(props) {
  const { children, dot, badge, icon, variant = "default", className = "" } = props;

  const base = "inline-flex items-center gap-2.5 rounded-full shadow-soft";

  return (
    <span className={`${base} ${variantClasses[variant]} ${className}`.trim()}>
      {badge ? (
        <span className="bg-coral rounded-full px-2 py-0.5 text-[10.5px] font-bold tracking-wider text-white">
          {badge}
        </span>
      ) : null}
      {dot ? (
        <span className="bg-azure animate-pulse-soft h-1.5 w-1.5 rounded-full shadow-[0_0_0_4px_rgba(3,169,244,0.2)]" />
      ) : null}
      {icon ? <span className="inline-flex">{icon}</span> : null}
      <span>{children}</span>
    </span>
  );
}
